import { List } from '@ksyos/design-system';
import type { TreatmentDescription } from './utils';

type TreatmentClassInformationProps = {
    isChecked: boolean;
    treatment: TreatmentDescription;
};

export function TreatmentClassInformation(props: Readonly<TreatmentClassInformationProps>) {
    const { treatment, isChecked } = props;

    if (!isChecked) {
        return null;
    }

    const treatmentList = treatment.extraInformation.map((info) => (
        <List.Item
            key={info}
            sx={{ fontWeight: 'medium' }}
        >
            {info}
        </List.Item>
    ));

    return (
        <List
            color="subtle"
            size="small"
            styleType="bullet"
            sx={{ mt: 2 }}
        >
            {treatmentList}
        </List>
    );
}
